<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 부가정보 : 소방 법정 점검-->
    <write-grid-container title="소방 법정 점검" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <fragment v-if="dataType === 'radio'">
            <PrintRadio v-for="_type in ['상반기', '하반기']" :key="`print_${_type}`" :value="form.subInfo[value] === _type" :label="_type" class="justify-center" />
          </fragment>
          <date-selector-rang v-else-if="dataType === 'daterang'" v-model="form.subInfo[value]" is-print/>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <custom-option-selector v-if="dataType === 'selector'" class="w-full" v-model="form.subInfo[value]" :options="result_options" />
          <date-selector-rang v-else-if="dataType === 'daterang'" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <FileDownloadPost title="파일첨부" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    FileDownloadPost,
    NumberInput,
    PrintRadio,
    CustomOptionSelector,
    DateSelectorRang,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      result_options: ["작동기능점검", "종합정밀점검", "기타"],
      gridContainerOptions: {
        dataTypes: ["selector", "daterang", "string"],
        labels: ["구분", "실시기간", "점검업체"],
        values: ["구분", "실시기간", "점검업체"],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
